import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { Analytics, getAnalytics, isSupported, logEvent, setUserProperties } from 'firebase/analytics';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private readonly router = inject(Router);
  private app?: FirebaseApp;
  private analytics?: Analytics;

  async init(): Promise<void> {
    if (!environment.firebaseConfig?.apiKey || !(await isSupported())) {
      return;
    }

    this.app = initializeApp(environment.firebaseConfig);
    this.analytics = getAnalytics(this.app);
    setUserProperties(this.analytics, { app_env: environment.name });
    this.trackPageViews();
  }

  logEvent(eventName: string, params?: Record<string, unknown>): void {
    if (!this.analytics) {
      return;
    }
    logEvent(this.analytics, eventName, params);
  }

  private trackPageViews(): void {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => {
        this.logEvent('page_view', {
          page_path: event.urlAfterRedirects,
          page_location: window.location.href,
        });
      });
  }
}
